import { useLayoutEffect } from 'react'
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom'
import { HelmetProvider } from 'react-helmet-async'
import { Header } from '@/components/ui/header-1'
import { Footer } from '@/components/layout/Footer'
import { Home, Work, About, Blog, BlogPostPage } from '@/routes'
import { Agentation } from 'agentation'

function PortfolioRoutes() {
  const { pathname, hash } = useLocation()
  useLayoutEffect(() => {
    const target = hash ? document.getElementById(hash.slice(1)) : null
    if (target) target.scrollIntoView({ behavior: 'instant', block: 'start' })
    else window.scrollTo({ top: 0, behavior: 'instant' })
    document.getElementById('main-content')?.focus({ preventScroll: true })
  }, [pathname, hash])

  return (
    <div className="portfolio-shell min-h-screen">
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/work" element={<Work />} />
        <Route path="/about" element={<About />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/blog/:slug" element={<BlogPostPage />} />
      </Routes>
      <Footer />
    </div>
  )
}

function App() {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <PortfolioRoutes />
        {import.meta.env.DEV && import.meta.env.VITE_AGENTATION === 'true' && <Agentation />}
      </BrowserRouter>
    </HelmetProvider>
  )
}

export default App
